import gql from 'graphql-tag'

export const GET_SURVEY_SUBMISSIONS = gql`
  query getSurveySubmission($surveyName: String, $surveySubmissionId: UUID) {
    getSurveySubmission(
      surveyName: $surveyName
      surveySubmissionId: $surveySubmissionId
    ) {
      id
      surveyId
      status
      pageId
      responses
    }
  }
`

/**
 * NOTE: if you add or remove from this, ensure you
 * also add to the {@link SEARCH_SALARIES} query
 */
export const GET_SURVEY_REVIEW = gql`
  query getSurveyReview($surveyName: String, $surveySubmissionId: UUID) {
    getSurveyReview(
      surveyName: $surveyName
      surveySubmissionId: $surveySubmissionId
    ) {
      academicAffiliation
      anyBonuses
      anyOtherIncome
      tailCoverage
      ancillaryIncomeSource
      avgHoursWorked
      baseSalary
      basePayPerHour
      benefitsWhenJoined
      bonus
      callPaid
      callPaidRate
      callSchedule
      callType
      callScheduleOther
      callScheduleDetails
      clinicalPct
      cmeAllowance
      cmeTimeWeeks
      collectionsPct
      compLoanAssistance
      compModel
      compSatisfaction
      compTargetWrvu
      dayOffPostCall
      employer401aMatch
      employer401kMatch
      employer403bMatch
      employer457bMatch
      employerCoversMalpractice
      employerType
      employerTypeDetails
      estimatedFte
      hourlyRateDifferential
      insuranceHealthWellnessBenefits
      jobType
      leadershipPct
      loanAssistance
      newJob
      nightlyHourlyRate
      occupationId
      otherBonus
      otherIncome
      otherNotableBenefits
      otherNoteworthyComp
      paidTimeOffWeeks
      parentalLeaveWeeks
      pensionContribution
      productivityBonus
      qualityBonus
      relocationBonus
      researchPct
      residencyStipend
      responsibilities
      retirementPlans
      salaryId
      scheduledDays
      scheduledHours
      shiftTiming
      signingBonus
      submittedByCurrentUser
      tailCoverage
      taxStatus
      teachingPct
      userLikes
      wrvuRate
      yearsOfExperience
      postedAt
      occupation {
        id
        slug
        fullTitle
        baseTitlePlusSpecialty
        professionId
        specialtyId
        profession {
          id
          name
          slug
          abbreviation
          alias
        }
        specialty {
          id
          name
          sub
          fullName
          baseSpecialtyId
        }
      }
      displayLocation
      annualEstAncillaryIncome
      annualEstPartnerIncome
      annualEstRankAdjustment
      annualLeadershipStipend
      annualNonClinicalIncome
      overtimeIncome
      overtimeRatePerHour
      weekendHourlyRate
      compTotal {
        base
        bonus
        other
        total
        annualBonus
        annualOther
      }
      locums {
        isCallStipend
        agencyBenefits
        agencyFeedback
        agencyName
        agencyRating
        callRatePerHour
        callStipendWeekendRate
        callStipendWeeklyRate
        contractActiveThruDate
        contractingEntity
        employerName
        guaranteedHrsPerDay
      }
      practiceSetting
      practiceSettingOther
    }
  }
`

export const SAVE_SURVEY_SUBMISSION = gql`
  mutation submitSurvey($input: SurveySubmissionInput!) {
    submitSurvey(input: $input) {
      id
    }
  }
`

export const SEARCH_NPI = gql`
  query searchNpi($input: NpiRegistrySearchInput!) {
    searchNpi(input: $input) {
      results {
        number
        addresses {
          address1
          city
          state
        }
        basic {
          firstName
          credential
          lastName
          middleName
        }
        taxonomies {
          desc
          primary
        }
      }
    }
  }
`

export const SEARCH_EMPLOYERS = gql`
  query searchEmployer($employerInput: EmployerSearchInput!) {
    searchEmployer(input: $employerInput) {
      results {
        id
        name
        logoUrl
        websiteUrl
      }
    }
  }
`

export const SEARCH_SPECIALTY = gql`
  query searchSpecialty($specialtyInput: SpecialtySearchInput!) {
    searchSpecialty(input: $specialtyInput) {
      results {
        id
        fullName
        sub
        name
        aliases
        baseSpecialtyId
        slug
      }
    }
  }
`

export const SEARCH_UNIVERSITY = gql`
  query searchUniversity($searchUniversityInput: UniversitySearchInput!) {
    searchUniversity(input: $searchUniversityInput) {
      results {
        id
        name
        location
      }
    }
  }
`

export const SEARCH_RESIDENCY_FELLOWSHIP = gql`
  query searchResidencyFellowship(
    $searchResidencyFellowshipInput: ResidencyFellowshipSearchInput!
  ) {
    searchResidencyFellowship(input: $searchResidencyFellowshipInput) {
      results {
        id
        location
        name
      }
    }
  }
`

export const SEARCH_APP_PROGRAM = gql`
  query searchAppProgram($searchAppProgramInput: AppProgramSearchInput!) {
    searchAppProgram(input: $searchAppProgramInput) {
      results {
        name
        id
        location
      }
    }
  }
`

export const SEARCH_CITY_STATE = gql`
  query searchCity($input: CitySearchInput!) {
    searchCity(input: $input) {
      results {
        id
        cityName
        stateCode
        displayLocation
      }
    }
  }
`

export const GET_LOCATION_DISPLAY_OPTIONS = gql`
  query getLocationDisplayOptions($input: LocationDisplayOptionsInput!) {
    getLocationDisplayOptions(input: $input) {
      locationDisplayLevels {
        displayName
        locationDisplayLevel
        order
      }
    }
  }
`
